<template>
  <div class="top">
    <div class="header">
      <span class="title">{{ title }}</span>
    </div>
    <div v-if="filterFormArea" class="filtrate-form">
      <slot name="filter-form"></slot>
    </div>
    <div v-if="$slots['btn-bar']" class="btn-bar">
      <slot name="btn-bar"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TableTop',
  props: {
    title: String,
    filterFormArea: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
    }
  },
  watch: {
  },
}
</script>
<style lang="scss" scoped>
.top{
  .header{
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #EAEEFB;
    margin-bottom: 20px;
    .title{
      font-size: 16px;
      font-weight: bold;
    }
    .icon{
      cursor: pointer;
    }
  }
  .btn-bar{
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-end;
  }
  .filtrate-form{

  }
}
</style>
